export default function FindingCommentDirective() {
  return {
    template: require('./finding-comment.html'),
    scope: {
      findingId: '=',
      canEdit: '=',
      canDelete: '=',
      findingComment: '=',
    },
    controller: 'FindingCommentController',
    controllerAs: 'findingCommentVM',
    bindToController: true,
    replace: true
  };
}
